import { render, staticRenderFns } from "./FIBRating.vue?vue&type=template&id=7bb1d489&"
import script from "./FIBRating.vue?vue&type=script&lang=js&"
export * from "./FIBRating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QRating from 'quasar/src/components/rating/QRating.js';
import qInstall from "../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QRating});
